import { useState } from 'react';
import styled from 'styled-components';
import { transNum } from '../../../func/func';
import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';
import Tags from '../../../func/Tags';
import { Sample } from './types';

interface Props {
  item: Sample;
}

const SampleCard = ({ item }: Props) => {
  const navigate = useNavigate();

  const translateType = (type: string) => {
    if (type === 'p') return '공매';
    if (type === 'n') return 'NPL';
    else return '경매';
  };

  const handleClickItem = () => {
    let url = '';
    if (item.type === 'p') url += '/pauction';
    else url += '/auction';

    url += `/detail/${item.iidx}`;

    if (item.type === 'n') url += '?type=b';

    window.open(url, '_blank');
  };

  return (
    <Container onClick={handleClickItem}>
      <CardImg>
        <img src={item.img} alt="" />
        <TypeTag>{translateType(item.type)}</TypeTag>
      </CardImg>
      <Content>
        <ColBox>
          <CaseNumber>{item.caseno}</CaseNumber>
          <Address>{item.address}</Address>
        </ColBox>

        <ColBox>
          <RowInfo>
            <Label>매각기일</Label>
            <Data>{item.sale_date}</Data>
          </RowInfo>
          <RowInfo>
            <Label>감정가</Label>
            <Data>{transNum(Number(item.a_prc))}원</Data>
          </RowInfo>
          <RowInfo>
            <Label>최저가</Label>
            <Data>{transNum(Number(item.m_prc))}원</Data>
          </RowInfo>
        </ColBox>

        <Tags data={{ ...item, bid: item.rn, viewgray2: item.viewgray }} />
      </Content>
    </Container>
  );
};

export default SampleCard;

const Container = styled.div`
  display: flex;
  min-width: 282px;
  width: 282px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const CardImg = styled.div`
  position: relative;
  width: 100%;
  height: 180px;

  & > img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
  }
`;

const TypeTag = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px 0;
  background: rgba(55, 56, 60, 0.61);
  backdrop-filter: blur(4px);

  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const ColBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const CaseNumber = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Address = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const RowInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Label = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-weight: 400;
  line-height: 145%;
  letter-spacing: -0.26px;
`;

const Data = styled.div`
  color: #222;
  font-size: 13px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.26px;
`;

const ImgTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
  background-color: rgba(55, 56, 60, 0.61);
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 6px 10px;
`;
const Inner = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 282px;
  background-color: #ffffff;
  margin-bottom: 24px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
`;

const HashTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;
`;

const HashTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  break-word: break-word;

  color: rgba(23, 30, 38, 0.78);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 17.4px;
  word-wrap: break-word;

  span {
    color: rgba(250, 64, 50, 0.98);
  }
`;

const ImgBox = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    border-radius: 8px;
    width: 282px;
    height: 180px;
  }
`;

const ItemPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  line-height: 18.85px;
  word-wrap: break-word;

  span {
    color: #222222;
    font-weight: 500;
  }
`;

const ItemPriceBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const InfoTitle = styled.div`
  color: #008aff;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;

  span {
    color: #616161;
    font-size: 14px;
    font-weight: 500;
    line-height: 20.3px;
  }
`;

const ItemInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  // padding: 16px;
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  color: #222222;
  font-size: 24px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 34.8px;
  word-wrap: break-word;
`;
